import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import BackgroundDiv from "./BackgroundDiv";
import CustomLink from "./CustomLink";
import { substring } from "../../../utils/utils";
import { withContainers, PopUpContainer, ResizeContainer } from "../normalizer";
import CustomButton from "./CustomButton";

const CHARACTED_LIMIT = 590;

function getDeviceType() {
  const width = window.innerWidth;
  if (width < 768) {
    return 'mobile';
  } else if (width >= 768 && width < 992) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}

const PopUpLayout = props => {
  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const updateDeviceType = () => {
      setDeviceType(getDeviceType());
    };

    window.addEventListener('resize', updateDeviceType);
    return () => window.removeEventListener('resize', updateDeviceType);
  }, []);

  const { image, title, description = "", show = false, untoggle, id, slug, fontFamily } = props;

  let imageSize;
  switch (deviceType) {
    case 'desktop':
      imageSize = 'banner_desktop_image';
      break;
    case 'mobile':
    case 'tablet':
      imageSize = 'banner_mobile_image';
      break;
    default:
      imageSize = 'banner_desktop_image';
  }

  // Try the cropped variant first (API often only populates cropped_image keys).
  const croppedImageSize = imageSize.replace('image', 'cropped_image');
  const imageUrl =
    (image[croppedImageSize] && image[croppedImageSize].url) ||
    (image[imageSize] && image[imageSize].url) ||
    (image['banner_desktop_cropped_image'] && image['banner_desktop_cropped_image'].url) ||
    (image['banner_desktop_image'] && image['banner_desktop_image'].url) ||
    '';

  const showButton = description.length > CHARACTED_LIMIT;
  const info = showButton
    ? substring(description, CHARACTED_LIMIT, "...")
    : description;

  return (
    <Modal show={show} untoggle={untoggle} large lessPadding>
      <div className="gl-popup">
        <div className="gl-popup__image">
          <BackgroundDiv
            className="gl-popup__image-bg"
            url={imageUrl}
          >
            <button type="button" className="gl2026-modal__close gl-popup__close" onClick={untoggle} aria-label="Fechar">
              <i className="fas fa-times" />
            </button>
          </BackgroundDiv>
        </div>
        <div className="gl-popup__body">
          <h3 className="gl-popup__title">{title}</h3>
          <div
            className="custom-inner-html gl-popup__info"
            dangerouslySetInnerHTML={{ __html: info }}
          />
          {showButton && (
            <div className="gl-popup__more">
              <CustomLink
                to={"/announcement/" + slug}
                className="gl-popup__button link-reset"
                onClick={untoggle}
              >
                Ver mais
              </CustomLink>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default withContainers(PopUpLayout,[PopUpContainer,ResizeContainer])
